import styled from 'styled-components';
import {getToken, getFontSize, getSpacing} from '@tickchak/react-share/app';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export const spacer = styled.div`
    ${dFlexCenter};
    gap: ${getSpacing('spaceMd')};
    padding: ${getSpacing('spaceMd')} 0;
    width: 100%;
    border-bottom: 1px solid ${getToken('color.border.subtle')};
`;

export const line = styled.div`
    flex: 1;
    height: 1px;
    border-top: 1px dashed ${getToken('color.border.default')};
`;

export const text = styled.span`
    color: ${getToken('color.text.default')};
    font-size: ${getFontSize('caption')};
`;
